import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { Outlet } from "react-router-dom";
import { Spinner } from "../components/Spinner";
import { ErrorBanner } from "../components/ErrorBanner";

/**
 * Route guard: requires an authenticated session. Unauthenticated users are
 * redirected to the Cognito Hosted UI. Shows a loading state while OIDC
 * initialises or a navigator is active.
 */
export function RequireAuth() {
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isLoading && !auth.isAuthenticated && !auth.activeNavigator && !auth.error) {
      void auth.signinRedirect();
    }
  }, [auth, auth.isLoading, auth.isAuthenticated, auth.activeNavigator, auth.error]);

  if (auth.isLoading || auth.activeNavigator) {
    return (
      <div className="centered-screen">
        <Spinner label="Loading your session…" />
      </div>
    );
  }

  if (auth.error) {
    return (
      <div className="centered-screen">
        <div className="auth-error-card">
          <ErrorBanner
            title="Sign-in failed"
            message={auth.error.message}
            onRetry={() => void auth.signinRedirect()}
            retryLabel="Try signing in again"
          />
        </div>
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    return (
      <div className="centered-screen">
        <Spinner label="Redirecting to sign in…" />
      </div>
    );
  }

  return <Outlet />;
}
